import React from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './index.module.less'
import Personal from './personal'
import usePersistStore from '@/store/persistStore'

const Nav = () => {
  const navigate = useNavigate()
  const { loginInfo = {} } = usePersistStore() as any

  const goHome = () => {
    navigate('/')
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.logo} onClick={goHome}>
          iKG
        </div>
        <div className={styles.right}>
          <div className={styles.tool}>
            <div className={styles.username}>{loginInfo?.name || ''}</div>
            <Personal />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Nav
